<style lang="css">

    .wrap-dialog .mask{position: fixed;z-index: 1000;top: 0;right: 0;left: 0;bottom: 0;background: rgba(0, 0, 0, .6);}
    .wrap-dialog .dialog{position: fixed;left: 50%;top: 20%;z-index:5000;transform: translateX(-50%);width: 42%;background: #ffffff;border-radius: 8px;}
    .wrap-dialog .dialog .title{padding:16px 0;;text-align: center;font-size: 20px;color: #7691FA;}
    .wrap-dialog .dialog .content{padding:20px 61px 0;}
    .wrap-dialog .dialog .content .wrap-input{display: flex;align-items: center;padding: 0 26px;height: 44px;margin-bottom:20px;background: #F9F9F9;border-radius: 20px;}
    .wrap-dialog .dialog .content .wrap-input .img{width: 28px;height: 28px;margin-right: 18px;}
    .wrap-dialog .dialog .content .wrap-input .input{width:100%;height:100%;border: none;background: #F9F9F9;}
    .wrap-dialog .dialog .content .wrap-input .input.width{width:55%;height:100%;border: none;background: #F9F9F9;}
    .wrap-dialog .dialog .content .wrap-input .input:focus{outline: none;}
    .wrap-dialog .dialog .content .wrap-input .input::-webkit-input-placeholder{font-size: 12px;color: #DEDEDE;}
    .wrap-dialog .dialog .content .wrap-input .code{position:relative;right:-40px;padding:0 20px;height:30px;line-height:30px;font-size:12px;color: #7691FA;border-radius: 16px;border: 1px solid #7691FA;cursor: pointer;}
    .wrap-dialog .dialog .confirm{width: 37%;height: 33px;margin: 0 auto 16px;line-height: 33px;font-size: 17px;text-align:center;color: #ffffff;border-radius: 20px;background: -webkit-linear-gradient(left,#2CA3FF,#7691FA);cursor: pointer;}
    .wrap-dialog .dialog .confirm.background{background: #7691FA;}
    .wrap-dialog .dialog .close-btn{position: absolute;right: -14px;top: -14px;width: 28px;height: 28px;cursor: pointer;}
    .wrap-dialog .dialog .remarks{padding: 8px 0 20px;text-align:center;font-size: 12px;color: #656565;}


    .wrap-dialog .dialog .content.scroll{height: 280px;overflow-y: auto;}
    .wrap-dialog .dialog .content .class-list{padding-bottom: 50px;}
    .wrap-dialog .dialog .content .class-list .class{width: 100%;height: 44px;line-height: 44px;margin-bottom:18px;text-align: center;font-size: 20px;color: #7691FA;border: 1px solid #7691FA;border-radius: 8px;cursor: pointer;}
    .wrap-dialog .dialog .content .class-list .class.active{color: #ffffff;background: #7691FA;}


    .wrap-dialog .dialog .content.add-pd{padding:20px 37px 0;}
    .wrap-dialog .dialog .content .add-input{display: flex;align-items:center;margin-bottom: 18px;}
    .wrap-dialog .dialog .content .add-input.flex-start{align-items: flex-start;}
    .wrap-dialog .dialog .content .add-input > span{margin-right:15px;color: #656565;font-size: 16px;}
    .wrap-dialog .dialog .content .add-input .input{width:82%;padding: 2px 0;border: none;border-bottom: 1px solid #E9E9E9;}
    .wrap-dialog .dialog .content .add-input .input:focus{outline: none;}
    .wrap-dialog .dialog .content .add-input .input::-webkit-input-placeholder{font-size: 16px;color: #DEDEDE;}
    .wrap-dialog .dialog .content .add-input .wrap-radio{width: 75%;}
    .wrap-dialog .dialog .content .add-input .radio{position: absolute;clip: rect(0,0,0,0)}
    .wrap-dialog .dialog .content .add-input .radio-row{display: flex;justify-content: space-between;margin-bottom: 10px;}
    .wrap-dialog .dialog .content .add-input .radio-row label{margin-bottom: 0;font-weight: normal;}
    .wrap-dialog .dialog .content .add-input .radio-row .radio + label::before{position:relative;top:1px;content: "";display: inline-block;width: 14px;height: 14px;margin-right: 5px;border-radius: 50%;border: 1px solid #7691FA;}
    .wrap-dialog .dialog .content .add-input .radio-row .radio:checked + label::before{background-color: #7691FA;background-clip: content-box;padding: 0.2em;}
    .wrap-dialog .dialog .content .add-input .radio-row .left,
    .wrap-dialog .dialog .content .add-input .radio-row .right{display: flex;align-items:center;font-size: 14px;}
</style>

<template lang="html">
	<div class="wrap-dialog">
		<div class="mask"></div>
        <div class="dialog">
            <div class="title">{{title}}</div>
            <slot></slot>
            <div class="confirm" :class="{background:background}" @click="onConfirm">{{confirmVal}}</div>
            <div class="remarks" v-if="remarks">备注：您尚未绑定手机端微信，请输入账号密码登录</div>
            <img src="./images/close.png" alt="" class="close-btn" @click="onClosed" >
        </div>
	</div>
</template>

<script>



export default {
	name : 'popup',
    props:{
        title: {
            default: null
        },
        confirmVal: {
            type: String,
            default: '确定'
        },
        remarks: {
            type: Boolean,
            default: false
        },
        background: {
            type: Boolean,
            default: false
        },
        funVal:{
            type: String,
            default: ''
        }
    },
	data: function(){
		return {

		}
	},
	components : {
	
	},
	mounted : function(){

	},

	computed:{

	},

    methods: {
        onConfirm:function(){
            this.$emit('onConfirm',{})
        },

        onClosed:function(){
            this.$emit('onClosed',{})
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/popup/dialog.vue